<template>
	<div class="bottom">
		<div class="btBox container">
			<div class="row" style="padding: 30px 0 10px;">
				<div class="left col-sm-8">
					<h1 class="logo" v-if="false">
						<router-link to="/">
              <!-- <img
								src="https://img.duoduiduo.com/goods/34/0/a294d25165c9437986ad2445327af516.jpg"
								:alt="this.seoName"> -->
                <img src="https://img.duoduiduo.com/gg/30/3/264e34ac1d0249619bfcc28e71db328b.png"
								:alt="this.seoName">
              </router-link>
					</h1>
					<div class="navList">
						<ul class="row">
							<li>
								<router-link to="/">首页</router-link>
							</li>
							<li>
								<router-link to="/matter">解决方案</router-link>
							</li>
							<li>
								<router-link to="/module">合作模式</router-link>
							</li>
							<li>
								<router-link to="/trade">合作案例</router-link>
							</li>
							<li>
								<router-link to="/about/synopsis?name=why">集团介绍</router-link>
							</li>
							<li>
								<router-link to="/news">新闻资讯</router-link>
							</li>
						</ul>
					</div>
					<h3 class="add" style="color: #ee8835;font-weight: 600;">
						广东多对多物联集团股份有限公司
					</h3>
					<div class="add">
						<span>集团本部</span>&nbsp;&nbsp;佛山市顺德区大良街道见龙山庄66号
					</div>
					<div class="add">
						<span>培训中心</span>&nbsp;&nbsp;广州市白云区白灰场路1号京隆大厦12层
					</div>
					<div class="add" style="cursor: pointer;" @click="goConcat('18676562256')">
						<span>业务联系电话</span>&nbsp;&nbsp;18676562256 陈先生
					</div>
					<div class="line"></div>
					<h3  @click="goConcat('4008600668')" style="cursor: pointer;font-weight: 600;">全国热线:400-8600-668</h3>
					<!-- <div class="add">
						总部地址：广东省佛山市顺德区大良街道顺峰社区见龙路6号见龙山庄41号
					</div>
					<div class="add">
						导航定位：广东多对多物联集团股份有限公司
					</div>
					<h3 class="tel2" style="cursor: pointer;color: #333" @click="toContact">
						服务热线：400-8600-668
					</h3>
					<div class="add">
						康养服务站丨容桂(暨南大学附属顺德医院 ·多对多物联集团数智健康家庭服务站)
					</div>
					<div class="add">
						中心地址：容桂文海花园12号铺
					</div>
					<div class="add">
						导航定位：多对多物联集团康养服务站
					</div>
					<div class="add" style="margin-bottom: 20px;">
						咨询热线：400-8600-668
					</div> -->
					<!-- <div class="tel">
						TEL：0757-28877270 &nbsp;&nbsp;&nbsp;HTTP://WWW.DUODUIDUO.COM
					</div>
					<div class="toTop" @click="toTop">
						↑↑ RETURN TO TOP
					</div> -->

				</div>
				<div class="right col-sm-4">
					<div class="ewmList row">
						
						<div class="item1 col-sm-6"><img style="width:129px;height:129px;"
								src="~img/home/gongzhonghao.jpg"
								alt=""><br>关注多对多<br>了解更多资讯</div>
						<div class="item2 col-sm-6"><img style="width:129px;height:129px;"
								src="~img/home/shipinhao.jpg"
								alt=""><br>关注多对多<br>视频号</div>
					</div>
					<div class="ewmList row" style="margin-top: 10px;">
						<div class="item1 col-sm-6"><img style="width:129px;height:129px;"
								src="~img/home/zhaoshang.jpg"
								alt=""><br>添加招商客服<br>获取更多商机</div>
								<div class="item1 col-sm-6"><img style="width:129px;height:129px;"
								src="~img/home/douyin.jpg"
								alt=""><br>关注多对多<br>抖音号</div>
					</div>
				</div>
			</div>
		</div>
		<div class="btBottom">
			<div class="btBox container">
				<div class="row">
					<div class="beian col-sm-9">
						<span style="margin-right: 6%">COPYRIGHT © 广东多对多物联集团股份有限公司</span>
						<span @click="toUrl" style="cursor: pointer">粤ICP备16028067号</span>

					</div>
					<div class="share col-sm-3">
						<ul>
							<li class="col"><img src="~img/home/weibo.png"></li>
							<li class="col"><img src="~img/home/txwb.png"></li>
							<li class="col"><img src="~img/home/wechat.png"></li>
							<li class="col"><img src="~img/home/qq.png"></li>
						</ul>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "bottom",
		created(){

		},
		methods: {
			goConcat(mobile){
				let flag = navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
					)
				if (flag) {
					window.location.href = `tel:${mobile}`;
				}
			},
			toContact() {
				let flag = navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
					)
				if (flag) {
					window.location.href = "tel:4008600668";
				}

			},
			toTop() {
				$('html , body').animate({
					scrollTop: 0
				}, 'slow');
			},
			toUrl() {
				window.open('_blank').location.href = 'https://beian.miit.gov.cn';
			}
		}
	}
</script>

<style scoped lang="less">
	.ewmList {
		// height: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		text-align: center;
	}

	.ewmList img {
		width: 100%;
	}

	.toTop {
		cursor: pointer;
		color: #EE7B1D;
		margin-bottom: 20px;
	}

	.toTop:hover {
		color: #F6AF5A;
	}

	.bottom .btBox .navList .row {
		margin: 0;
		margin-bottom: 15px;
	}

	.bottom .add,
	.tel,
	.tel2 {
		line-height: 40px;
	}
	.bottom .add span{
		font-weight: 600;
	}
	.bottom .line{
		width: 55%;
		margin: 10px 0;
		border-bottom: 1px dashed rgb(137, 137, 137);
	}
	.bottom .btBox .navList ul li {
		padding: 0 7px;
		line-height: 30px;
		border-bottom: 1px solid #333;
	}

	.navList ul li a:hover {
		color: #ee8835 !important;
	}

	.bottom .btBox .right .ewmList div {
		@media (max-width: 576px) {
			margin-bottom: 20px;

			img {
				width: 50%;
				text-align: center;
			}
		}

		@media (max-width: 990px) {
			padding: 0 5px;

			&.item1 {
				padding-top: 24px;
			}
		}
	}

	.logo {
		width: 150px;
		padding: 30px 0;
	}

	@media (max-width: 576px) {
		.logo {
			display: none;
		}

		.navList {
			padding-top: 40px;
		}

	}

	a {
		display: inline-block;
		width: 100%;
		height: 100%;
		color: #333 !important;
	}

	a:hover {
		color: #333 !important;
		text-decoration: none !important;
	}

	.logo a img {
		width: 100%;
	}

	.btBottom {
		padding: 5px 0;
		background: #333;

		.btBox {
			color: #898989;

			.beian {
				padding: 0 10px;
				display: flex;
				align-items: center;
				font-size: 14px;

				@media (max-width: 750px) {
					flex-direction: column;
					vertical-align: middle;
					line-height: 30px;
				}

				span:nth-child(2):hover {
					color: #fff;
				}
			}
		}

		.share ul {
			display: flex;
			justify-content: space-between;
			margin: 5px 0;
			text-align: center;
			flex-wrap: wrap;

			li {
				margin-bottom: 6px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/bottom.vue